import {
  Cube as CubeIcon,
  FileText as FileTextIcon,
} from "@phosphor-icons/react";

const KIND_ICONS = {
  maquette: { Icon: CubeIcon, label: "Maquette" },
  compte_rendu: {
    Icon: FileTextIcon,
    label: "Compte-rendu, pièces jointes comprises",
  },
};

export type DocumentKindIconProps = {
  kind: "document" | "maquette" | "compte_rendu";
};

/** Picto of a diffusion row that is not a plain document. */
export function DocumentKindIcon({ kind }: DocumentKindIconProps) {
  if (kind === "document") return null;
  const { Icon, label } = KIND_ICONS[kind];
  return (
    // The title sits on a wrapper: an SVG has no native hover text.
    <span title={label} className="shrink-0">
      <Icon size={16} className="text-zinc-500" aria-label={label} />
    </span>
  );
}
